// extracted by mini-css-extract-plugin
module.exports = {"searchContainer":"SchoolSearchContainer_searchContainer__1b9O3"};